import React from 'react'
import VehicleConfirmContainer from './VehicleConfirmContainer'

const VehicleConfirm = props => (
  <VehicleConfirmContainer {...props} data-test="component-tradeIn-vehicleConfirm" />
)

export default VehicleConfirm
